<template>
    <div>
        <v-card
            flat>
            <v-card-title>
                {{ $t('ITEM_PAGE_TITLE') }}
                <v-spacer></v-spacer>
                <v-text-field
                    append-icon="mdi-magnify"
                    :label="$t('ITEM_PAGE_SEARCH')"
                    v-model="search"
                    hide-details
                    class="ml-4"
                    @keypress.enter="createdItemsFetch()"
                ></v-text-field>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            link
                            v-if="authorizations.items.create"
                            @click="openItemDialog({editMode: false})"
                            >
                            <v-list-item-avatar>
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>
                                {{ $t('new_item') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.items.update && selected.item.length == 1"
                            link
                            @click="openItemDialog({editMode: true, id: selected.item[0].id})"
                            :disabled="!selected.item[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.item[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.items.delete && selected.item.length == 1"
                            link
                            @click="openItemDeleteDialog(selected.item[0].id)"
                            :disabled="!selected.item[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.item[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>{{ $t('ITEMS_PAGE_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <v-data-table
                    single-select
                    show-select
                    dense
                    v-model="selected.item"
                    :items="items"
                    :headers="headers.items"
                    :search="search"
                    :options.sync="options"
                    :server-items-length="itemsLength"
                    :loading="loading.data">
                </v-data-table>
            </v-card-text>
        </v-card>
        <ItemDialog
            ref="itemDialog"
            @submit="createdItemsFetch()"/>
        <AlertDialog
            ref="alertDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ItemDialog from '../components/ItemDialog';
import AlertDialog from '../components/AlertDialog';
import DecisionDialog from '../components/DecisionDialog';
export default {
    name: "Items",
    components: {
        ItemDialog,
        AlertDialog,
        DecisionDialog
    },
    data() {
        return {
            itemsLength: 0,
            search: null, 
            loading: {
                data: true
            },
            selected: {
                item: []
            },
            headers: {
                items: [
                    {text: "ID", value: "id"},
                    {text: this.$t('ITEM_NAME'), value: "name"},
                    {text: this.$t('ITEM_PART_NUMBER'), value: "part_number"},
                    {text: this.$t('ITEM_DESCRIPTION'), value: "description"}
                ]
            },
            options: {}
        }
    },
    computed: {
        ...mapState("authentication", ["authorizations"]),
        ...mapState("item", ["items"])
    },
    watch: {
        options: {
            handler() {
                this.createdItemsFetch();
            }
        }
    },
    methods: {
        ...mapActions("item", ["fetchItems", "removeItem"]),
        openItemDialog(params) {
            this.$refs.itemDialog.open(params);
        },
        openItemDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE_ITEM",
                id: id
            });
        },
        async createdItemsFetch() {
            try {
                this.loading.data = true;
                this.options.search = this.search;
                let response = await this.fetchItems(this.options);
                this.itemsLength = response.data.total;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.alertDialog(this.$t("error_title"), message); 
            }
        },
        submitDecisionDialog(params) {
            if(params.action == "DELETE_ITEM") {
                this.removeItem(params.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.createdItemsFetch();
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    }
}
</script>